import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { checkCurrentSurvey } from '~/hoc/checkCurrentSurvey'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyQuery } from '~/hooks/useSurveyQuery'

import { CustomerAttributeSettings } from './components/CustomerAttributeSettings'

export const CustomerAttributeSettingsPage = checkCurrentSurvey(() => {
  const { isLoading } = useSurveyQuery()

  useLogEventOnMount('Access to customer attribute settings')

  return (
    <Suspense loading={isLoading}>
      <CustomerAttributeSettings />
    </Suspense>
  )
})
